import React from "react";
import PreProjectRow from "./PreProjectRow";
import SearchInput from "../../../Common/SearchInput/SearchInput";
import FilterDropdown from "../../../Common/FilterDropdown/FilterDropdown";
import { utils } from "../../../../helpers/utils";
import { appActions } from "../../../../redux/actions/appActions";
import { connect } from "react-redux";
import { debounce } from "debounce";
import { adminSettingsActions } from "../../../../redux/actions/adminSettingsActions";
import FlagIcon from "../../../Common/FlagIcon/FlagIcon";
import Input from "../../../Common/Input/Input";
import "./PreProject.css";
import SkeletonLoading from "../../../Common/SkeletonLoading/SkeletonLoading";
import Button from "../../../Common/Button/Button";
import Drawer from "../../../Common/Drawer/Drawer";
import FilterVector from "../../../../images/FilterVector.svg";

class PreProjectTab extends React.Component {
  constructor(props) {
    super(props);
    this.searchDebouncedData = debounce(this.searchData, 300);
    this.state = {
      openDrawer: false,
      selectedStatusFilters: [],
      selectedFlagFilters: [],
      state: "Show All Applications",
      programStream: [],
    };
  }

  componentDidMount() {
    if (this.props.currentProgram === "retrofit") {
      this.props.loadAdminConfigRetrofit();
    } else {
      this.props.loadAdminConfig();
    }
    this.searchData(true);
  }

  ShowMoreDetails = (id) => {
    let actElem = document.getElementById(id);
    if (actElem.classList.contains("active-row")) {
      actElem.classList.remove("active-row");
    } else {
      let actContElem = document.querySelector(".preproject-details-row.active-row");
      if (actContElem !== null) {
        actContElem.classList.remove("active-row");
      }
      actElem.classList.add("active-row");
    }
  };

  onStatusFilterChange = (SelectedStatusFilters) => {
    this.props.setFilters("Pre-Project", {
      SelectedStatusFilters,
    });
  };

  onFlagFilterChange = (SelectedFlagFilters) => {
    this.props.setFilters("Pre-Project", {
      SelectedFlagFilters,
    });
  };

  onSearch = (searchInput) => {
    this.props.setFilters("Pre-Project", {
      searchInput,
    });
  };

  searchData = (refresh = false) => {
    const { sortConfig, SelectedStatusFilters, SelectedFlagFilters, onlyActiveApps, currentProgram, StageFilters } = this.props;
    let config = {
      statuses: SelectedStatusFilters,
      flags: SelectedFlagFilters,
      sort: sortConfig,
      stage: StageFilters,
      reviewerId: this.props.reviewerId,
      activeApps: onlyActiveApps,
      program: currentProgram,
      stream: this.state.programStream,
    };
    if (currentProgram === "retrofit") {
      this.props.getApplicationsToReviewRetrofit(
        "Pre-Project",
        this.props.searchInput,
        config,
        refresh ? 0 : this.props.reviewAppListOffset
      );
    } else {
      this.props.getApplicationsToReview("Pre-Project", this.props.searchInput, config, refresh ? 0 : this.props.reviewAppListOffset);
    }
  };

  handleListScroll = () => {
    if (this.props.moreReviewApps) {
      this.searchDebouncedData();
    }
  };

  sortData = (property) => {
    this.props.setFilters("Pre-Project", {
      sortConfig: { name: property, direction: this.props.sortConfig.direction === "desc" ? "asc" : "desc" },
    });
  };
  onStateChange = (name, val) => {
    this.props.setFilters("Pre-Project", {
      onlyActiveApps: !val ? [true] : [true, false],
    });
  };

  toggleDrawer = (status) => {
    let updateObj = {
      openDrawer: status,
    };
    this.setState(updateObj);
  };

  handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    let checkedStatus = this.state[name];
    if (checked) {
      // push selected value in list
      checkedStatus = [...checkedStatus, value];
    } else {
      // remove unchecked value from the list
      checkedStatus = checkedStatus.filter((x) => x !== value);
      // setLang(prev => prev.filter(x => x !== value));
    }
    this.setState({
      [name]: checkedStatus,
    });
  };
  onChangeRadio = (e) => {
    const { name, value } = e.target;
    if (value === "Show All Applications") {
      this.setState({ [name]: "Show All Applications" });
    } else if (value === "Hide Inactive Applications") {
      this.setState({ [name]: "Hide Inactive Applications" });
    } else {
      this.setState({ [name]: value });
    }
  };

  applyFiters = () => {
    const { state, selectedFlagFilters, selectedStatusFilters, programStream } = this.state;
    this.props.setFilters("Pre-Project", {
      SelectedFlagFilters: selectedFlagFilters,
      SelectedStatusFilters: selectedStatusFilters,
      stream: programStream,
      onlyActiveApps: state === "Hide Inactive Applications" ? [true] : state === "Hide Active Applications" ? [false] : [true, false],
    });
    this.toggleDrawer(false);
  };

  clearFilters = () => {
    this.props.setFilters("Pre-Project", {
      SelectedFlagFilters: [],
      SelectedStatusFilters: [],
      stream: [],
      onlyActiveApps: [true, false],
    });
    this.setState({
      selectedStatusFilters: [],
      selectedFlagFilters: [],
      state: "Show All Applications",
      programStream: [],
    });
  };

  render() {
    const {
      reviewAppStage,
      applicationsToReviewLoading,
      reviewAppList,
      SelectedStatusFilters,
      SelectedFlagFilters,
      configData,
      onlyActiveApps,
      currentProgram,
      reviewerId,
    } = this.props;
    const { openDrawer, state, programStream, selectedFlagFilters, selectedStatusFilters } = this.state;
    let flagsList = [];
    let FilterOptions = [];
    let reviewList = reviewAppList;
    if (configData) {
      if (currentProgram === "retrofit") {
        FilterOptions = configData.appStatuses["Pre-Project"].map((item) => item.applicationStatusName);
        let preProjectFlags = configData.appFlags.flags.filter((item) => item.stage === "Pre-Project");
        flagsList = preProjectFlags.map((item) => {
          return { value: item.status, icon: <FlagIcon color={item.colorCode} /> };
        });
        reviewList =
          reviewAppList &&
          reviewAppList.filter((app) => {
            if (app.isPrimaryReviewer) {
              if (app.reviewer && app.reviewer.value === reviewerId) {
                return app;
              }
            } else {
              if (app.secondaryReviewer && app.secondaryReviewer.value === reviewerId) {
                return app;
              }
            }
          });
      } else {
        flagsList = configData.appFlags.flags.map((item) => {
          return { value: item.status, icon: <FlagIcon color={item.colorCode} /> };
        });
        FilterOptions = configData.appStatuses["Pre-Project"].map((item) => item.status);
      }
    }
    let diffPrograms = [
      { label: "Energy Savings For Business", value: "esb" },
      { label: "Comprehensive Energy Savings", value: "ces" },
    ];
    return (
      <div className="reviews-tab">
        <Drawer toggleDrawer={this.toggleDrawer} openDrawer={openDrawer} className={"program-panel-drawer"}>
          <div className="filter-drawer">
            <h3>FILTER BY</h3>
            {configData ? (
              <div className="all-filters">
                <div className="filter">
                  <label className="filter-label">Status</label>
                  <div className="filter-options">
                    {FilterOptions.map((status, i) => {
                      return (
                        <label key={i}>
                          <input
                            type="checkbox"
                            name="selectedStatusFilters"
                            checked={selectedStatusFilters.includes(status)}
                            value={status}
                            onChange={(e) => this.handleCheckboxChange(e)}
                          />{" "}
                          {status}
                        </label>
                      );
                    })}
                  </div>
                </div>
                <div className="filter">
                  <label className="filter-label">Flag</label>
                  <div className="filter-options">
                    {flagsList.map((flagItem, i) => {
                      return (
                        <label key={i}>
                          <input
                            type="checkbox"
                            name="selectedFlagFilters"
                            checked={selectedFlagFilters.includes(flagItem.value)}
                            value={flagItem.value}
                            onChange={(e) => this.handleCheckboxChange(e)}
                          />{" "}
                          <span>{flagItem.icon}</span>
                          {flagItem.value}
                        </label>
                      );
                    })}
                  </div>
                </div>
                <div className="filter">
                  <label className="filter-label">State</label>
                  <div className="filter-options">
                    {
                      <div onChange={(e) => this.onChangeRadio(e)}>
                        <label>
                          <input type="radio" checked={state === "Show All Applications"} value="Show All Applications" name="state" /> Show
                          All Applications
                        </label>
                        <label>
                          <input
                            type="radio"
                            checked={state === "Hide Inactive Applications"}
                            value="Hide Inactive Applications"
                            name="state"
                          />{" "}
                          Hide Inactive Applications
                        </label>
                        <label>
                          <input
                            type="radio"
                            checked={state === "Hide Active Applications"}
                            value="Hide Active Applications"
                            name="state"
                          />{" "}
                          Hide Active Applications
                        </label>
                      </div>
                    }
                  </div>
                </div>
                <div className="filter">
                  <label className="filter-label">Program</label>
                  <div className="filter-options">
                    {diffPrograms.map((program, i) => {
                      return (
                        <label key={i}>
                          <input
                            type="checkbox"
                            name="programStream"
                            checked={programStream.includes(program.value)}
                            value={program.value}
                            onChange={(e) => this.handleCheckboxChange(e)}
                          />
                          {program.label}
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <Button className="inversed-btn drawer-btn first-btn" title="Clear All Filters" onClick={this.clearFilters} />
          <Button className="drawer-btn" title="Apply Filters" onClick={this.applyFiters} />
        </Drawer>
        <div className="reviews-top-bar">
          <div className="reviews-top-bar-search">
            <SearchInput value={this.props.searchInput} placeholder="Search for Applications" onClick={this.onSearch} />
          </div>
          {currentProgram === "esb" ? (
            <div className="reviews-top-bar-filter-btn">
              <Button
                className="filter-btn"
                uppercase
                title={"Filters"}
                svg={FilterVector}
                onClick={() => this.setState({ openDrawer: true })}
              />
            </div>
          ) : null}
          {currentProgram === "esb" ? null : (
            <>
              <div className="reviews-top-bar-filter">
                {configData ? (
                  <FilterDropdown
                    label={"Filter by Status"}
                    FilterOptions={FilterOptions}
                    SelectedFilters={SelectedStatusFilters}
                    onChange={this.onStatusFilterChange}
                    className={"program-filter"}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="reviews-top-bar-filter">
                {configData ? (
                  <FilterDropdown
                    label={"Filter by Flag"}
                    iconBasedOption={true}
                    iconClass="flag-filter"
                    FilterOptions={flagsList}
                    SelectedFilters={SelectedFlagFilters}
                    onChange={this.onFlagFilterChange}
                    className={"program-filter"}
                  />
                ) : (
                  ""
                )}
              </div>
              {currentProgram !== "retrofit" ? (
                <div className="appstate-details">
                  {configData ? (
                    <React.Fragment>
                      <Input type="switch" name="appState" checked={onlyActiveApps.includes(false)} onChange={this.onStateChange} />
                      <div className="appstate-text">
                        {onlyActiveApps.includes(false) ? "Show All Applications" : "Hide Inactive Applications"}
                      </div>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
        <div className="preproject-details-header preproject-details-row">
          {currentProgram !== "retrofit" ? (
            <div className="preproject-details">
              <div onClick={() => this.sortData("appNo", "string")}>ID</div>
              <div onClick={() => this.sortData("companyName", "string")}>Customer</div>
              <div onClick={() => this.sortData("contractor.label", "string")}>Contractor</div>
              <div onClick={() => this.sortData("status", "string")}>Status</div>
              <div onClick={() => this.sortData("Pre-Project - Application Draft Under Review Time", "date")}>Assigned for Review</div>
              <div onClick={() => this.sortData("Pre-Project - Application Draft Under Review Time", "number")}>Days in Review</div>
              <div onClick={() => this.sortData("Pre-Project - Application Draft Submitted Time", "date")}>Submitted Date</div>
              <div onClick={() => this.sortData("Estimated Incentive", "number")}>Estimated Incentive</div>
              <div onClick={() => this.sortData("IRResponseReceived", "string")}>IR Response Received</div>
              <div></div>
            </div>
          ) : (
            <div className="preproject-details">
              <div onClick={() => this.sortData("application_id", "string")}>ID</div>
              <div onClick={() => this.sortData("application_name", "string")}>Application Name</div>
              <div onClick={() => this.sortData("application_project_type", "string")}>Application Project Type</div>
              <div onClick={() => this.sortData("applicant_account_id", "string")}>Email</div>
              <div onClick={() => this.sortData("multi_site", "string")}>Multi-Site</div>
              <div onClick={() => this.sortData("application_status_name", "string")}>Status</div>
              <div onClick={() => this.sortData("creation_dt", "date")}>Created Date</div>
              <div onClick={() => this.sortData("pre_project_submission_date", "date")}>Submitted Date</div>
              <div onClick={() => this.sortData("total_est_app_incentive", "number")}>Estimated Incentive</div>
              <div onClick={() => this.sortData("pre_project_resubmission", "string")}>IR Response</div>
              <div></div>
            </div>
          )}
        </div>
        <div className="preproject-details-list" id="CustomerDetailsList" onScroll={this.handleListScroll}>
          {applicationsToReviewLoading && (reviewAppStage === "" || reviewAppStage !== "Pre-project") ? (
            <SkeletonLoading />
          ) : reviewList && reviewList.length ? (
            reviewList.map((application, i) => (
              <PreProjectRow
                application={application}
                key={`application-${i}`}
                id={`application-${i}`}
                currentProgram={currentProgram}
                showActionModal={this.props.showActionModal}
                ShowMoreDetails={this.ShowMoreDetails}
              />
            ))
          ) : (
            <div className="no-records-found">No records.</div>
          )}
        </div>
      </div>
    );
  }
}

function mapState(state) {
  const { configData } = state.settings;
  const { currentProgram } = state.authentication;
  const {
    reviewAppList,
    reviewAppStage,
    reviewAppListOffset,
    applicationsToReviewLoading,
    appStatusLogsLoading,
    activeStatusLogs,
    moreReviewApps,
  } = state.application;
  return {
    currentProgram,
    reviewAppStage,
    reviewAppList,
    reviewAppListOffset,
    applicationsToReviewLoading,
    appStatusLogsLoading,
    activeStatusLogs,
    moreReviewApps,
    configData,
  };
}

const actionCreators = {
  getApplicationsToReview: appActions.getApplicationsToReview,
  getApplicationsToReviewRetrofit: appActions.getApplicationsToReviewRetrofit,
  loadAdminConfig: adminSettingsActions.getAdminConfig,
  loadAdminConfigRetrofit: adminSettingsActions.getAdminConfigRetrofit,
};

export default connect(mapState, actionCreators)(PreProjectTab);
